// extracted by mini-css-extract-plugin
module.exports = {"twitterTimelineFallback":"twitter-timeline_twitterTimelineFallback__nxDE6"};